import React from 'react';
import styled from 'styled-components';
import { Button, FlexColumn, FlexRow } from '@make-software/cspr-design';
import { TextModal } from '@/components';

interface ConfirmationModalProps {
  text: string;
  buttonText?: string;
  onSubmit: () => void;
}

export const StyledButton = styled(Button)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer'
  })
);

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ text, buttonText, onSubmit }) => {
  return (
    <FlexColumn gap={25}>
      <TextModal text={text} />
      <FlexRow>
        <StyledButton onClick={onSubmit}>{buttonText || 'Ok'}</StyledButton>
      </FlexRow>
    </FlexColumn>
  );
};
